<div [formGroup]="this.getFormGroup(inputFormGroup)">
  <p-input-group>
    <input
      [formControlName]="inputControlName"
      [ngClass]="inputClass"
      appAmountInput
      pInputText
      />
    @if (addon) {
      <p-inputGroupAddon class="bg-transparent">
        <i [class]="addon" style="font-size: 0.7rem"></i>
      </p-inputGroupAddon>
    }
  </p-input-group>
</div>
